<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('询价记录.活动名称')" prop="activityName">
                <a-input v-model="queryParam.activityName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('询价记录.活动名称')" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('询价记录.开始时间')" prop="startTime">
                <a-date-picker style="width: 100%" v-model="queryParam.startTime" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('询价记录.是否上架')" prop="isSell">
                <a-select style="width: 100%" v-model="queryParam.isSell" :placeholder="$t('通用.输入.请选择')+$t('询价记录.是否上架')">
                  <a-select-option  :value="0" :key="0">否</a-select-option>
                  <a-select-option  :value="1" :key="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('询价记录.询价状态')" prop="status">
                  <a-select style="width: 100%" v-model="queryParam.status" :placeholder="$t('通用.输入.请选择')+$t('询价记录.询价状态')">
                    <a-select-option  :value="10" :key="10">预告</a-select-option>
                    <a-select-option  :value="20" :key="20">进行中</a-select-option>
                    <a-select-option  :value="30" :key="30">已结束</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('询价记录.结束时间')" prop="endTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.endTime" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('询价记录.最晚交期')" prop="deliveryTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.deliveryTime" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['activityXunjia:activityXunjia:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['activityXunjia:activityXunjia:edit']">-->
<!--          <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['activityXunjia:activityXunjia:remove']">-->
<!--          <a-icon type="delete" />{{$t('通用.按钮.删除')}}-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['activityXunjia:activityXunjia:export']">-->
<!--          <a-icon type="download" />{{$t('通用.按钮.导出')}}-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <!-- 增加详情 -->
      <xunjia-detail
        ref="xunjiaDetail"
        @ok="getList"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >

         <span slot="checkissell" slot-scope="text, record">
           <span v-if="record.isSell == '0'">
             否
           </span>
           <span v-if="record.isSell == '1'">
            是
           </span>
        </span>
        <span slot="checkpayType" slot-scope="text, record">
           <span v-if="record.payType == '10'">
             现金支付
           </span>
           <span v-if="record.payType == '20'">
            线上转账
           </span>
        </span>
        <span slot="checkexpressType" slot-scope="text, record">
           <span v-if="record.expressType == '10'">
             同城快运
           </span>
        </span>
        <span slot="checkstatus" slot-scope="text, record">
           <span v-if="record.status == '10'">
             预告
           </span>
           <span v-if="record.status == '20'">
            进行中
           </span>
          <span v-if="record.status == '30'">
            已结束
           </span>
           <span v-if="record.status == '40'">
            已开标
           </span>
        </span>

        <span slot="startTime" slot-scope="text, record">
          {{ parseTime(record.startTime) }}
        </span>
        <span slot="endTime" slot-scope="text, record">
          {{ parseTime(record.endTime) }}
        </span>
        <span slot="deliveryTime" slot-scope="text, record">
          {{ parseTime(record.deliveryTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">

<!--          询价状态 10:预告 20:进行中 30:已结束 40:已开标-->
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['activityXunjia:activityXunjia:edit']"
             v-if="record.status==10">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" v-if="record.status==10" v-hasPermi="['activityXunjia:activityXunjia:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['activityXunjia:activityXunjia:remove']"
             v-if="record.status==10">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>

           <a-divider type="vertical" v-if="record.status==10" v-hasPermi="['activityXunjia:activityXunjia:remove']" />
           <a @click="$refs.xunjiaDetail.handleUpdate(record, undefined)">
            <a-icon type="view" />详情
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageActivityXunjia,listActivityXunjia, delActivityXunjia } from '@/api/activityXunjia/activityXunjia'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import XunjiaDetail from './modules/XunjiaDetail'
export default {
  name: 'ActivityXunjia',
  components: {
    CustomDictTag,
    CreateForm,
    XunjiaDetail
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        activityName: undefined,
        startTime: undefined,
        endTime: undefined,
        deliveryTime: undefined,
        payBond: undefined,
        bondMoney: undefined,
        endMoney: undefined,
        isSell: undefined,
        payType: undefined,
        expressType: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: this.$t('询价记录.商品id'),
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('询价记录.活动名称'),
          dataIndex: 'activityName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('询价记录.开始时间'),
          dataIndex: 'startTime',
          scopedSlots: { customRender: 'startTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('询价记录.结束时间'),
          dataIndex: 'endTime',
          scopedSlots: { customRender: 'endTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('询价记录.最晚交期'),
          dataIndex: 'deliveryTime',
          scopedSlots: { customRender: 'deliveryTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('询价记录.是否需要缴纳保证金 0:否 1:是'),
        //   dataIndex: 'payBond',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价记录.保证金金额'),
        //   dataIndex: 'bondMoney',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价记录.底价'),
        //   dataIndex: 'endMoney',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('询价记录.是否上架'),
          dataIndex: 'isSell',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'checkissell'},
        },
        {
          title: this.$t('询价记录.付款方式'),
          dataIndex: 'payType',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'checkpayType'},
        },
        {
          title: this.$t('询价记录.物流方式'),
          dataIndex: 'expressType',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'checkexpressType'},
        },
        {
          title: this.$t('询价记录.询价状态'),
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'checkstatus'},
        },
        // {
        //   title: this.$t('询价记录.排序'),
        //   dataIndex: 'sort',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价记录.创建时间'),
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: this.$t('询价记录.备注'),
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询询价记录列表 */
    getList () {
      this.loading = true
     pageActivityXunjia(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        activityName: undefined,
        startTime: undefined,
        endTime: undefined,
        deliveryTime: undefined,
        payBond: undefined,
        bondMoney: undefined,
        endMoney: undefined,
        isSell: undefined,
        payType: undefined,
        expressType: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delActivityXunjia(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('activityXunjia/activityXunjia/export',
            ...that.queryParam
          , `询价记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
